import { normalizeLegacyMarkup } from '../shared/legacyTemplates';
import { handleSearch } from '../shared/commonSearchFunction';

import '../../util/static/defaultlist.css';

normalizeLegacyMarkup('sv-standardsearch-portlet');
handleSearch('sv-standardsearch-portlet', true);
